var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExclamation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.354156 12.0001C0.354156 5.56826 5.56817 0.354248 12 0.354248C18.4318 0.354248 23.6458 5.56826 23.6458 12.0001C23.6458 18.4319 18.4318 23.6459 12 23.6459C5.56817 23.6459 0.354156 18.4319 0.354156 12.0001ZM10.9167 16.3334C10.9167 15.7351 11.3995 15.2501 11.9951 15.2501H12.0048C12.6005 15.2501 13.0833 15.7351 13.0833 16.3334C13.0833 16.9317 12.6005 17.4167 12.0048 17.4167H11.9951C11.3995 17.4167 10.9167 16.9317 10.9167 16.3334ZM10.9167 12.0001C10.9167 12.5984 11.4017 13.0834 12 13.0834C12.5983 13.0834 13.0833 12.5984 13.0833 12.0001V7.66675C13.0833 7.06844 12.5983 6.58341 12 6.58341C11.4017 6.58341 10.9167 7.06844 10.9167 7.66675L10.9167 12.0001Z",
    fill: "#DDA200"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamation);
export default __webpack_public_path__ + "static/media/exclamation.52469fbf13669b0b38e35ecb8d2394c1.svg";
export { ForwardRef as ReactComponent };